// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--eYBJR","content":"_1410bfd27b--content--zhJCE","text":"_1410bfd27b--text--GlSmS","image":"_1410bfd27b--image--idhYt"};